import React, { Component } from "react";
import Validator from "util/form-validator";
import Field from "visual-components/util/inputs/field";

export default class FbShare extends Component {
  componentDidMount() {
    this.refs.field.validate(this.refs.field.valueFromDataModel());
  }

  render() {
    const {
      bonus: { id, partnership_invite_id },
      bonusItems,
    } = this.props;

    return (
      <Field
        id={id}
        ref={"field"}
        label={"Facebook Share Message"}
        attrName={"facebookShareMessage"}
        endpoint={`/partnership-bonus/${partnership_invite_id}/${id}`}
        dataModel={bonusItems}
        formModel={bonusItems}
        validations={[Validator.required]}
        placeholder="Message to share (e.g., Check out this amazing campaign!)"
      />
    );
  }
}
